const STEPS = {
  FETCHING: 'FETCHING',
  ONBOARDING: 'ONBOARDING',
  READY: 'READY',
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  NOT_OPENED: 'NOT_OPENED',
  ADMISSION_REJECTED: 'ADMISSION_REJECTED'
}

const ENV = {
  PLAYGROUND: 'PLAYGROUND',
  CLASSROOM: 'CLASSROOM',
  RECORDING: 'RECORDING',
  SKETCHPAD: 'SKETCHPAD'
}

const FEATURES = {
  TOOL_PANEL_TOGGLE: 'tool_panel_toggle', // sketch/notes/code/files toggles in header, or close button
  TOOL_NEW_FILE: 'tool_new_file', // new file button in all tools empty panel and in the tabbar
  TOOL_SWITCH_FILE: 'tool_switch_tab', // switch between tabs in the tabbar, close current file, open different file
  TOOL_RENAME_FILE: 'tool_rename_file', // rename file in the tabbar
  TOOL_EDIT: 'tool_edit', // edit (draw in sketch, type in note/code) permission tools

  SKETCH_ERASER: 'sketch_eraser',
  SKETCH_UNDO_REDO: 'sketch_undo_redo',

  SCREEN_SHARE_TOGGLE: 'screen_share',
  VIDEO_UPLOAD_CUSTOM_BACKGROUNDS: 'video_upload_custom_backgrounds',

  FULL_SCREEN_TOGGLE: 'full_screen'
}

export default {
  STEPS,
  ENV,
  FEATURES
}
